import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ClutchLayout } from "./screens/clutch/ClutchContext";
import GetStarted from "./screens/clutch/GetStarted";
import Details from "./screens/clutch/Details";
import Instructions from "./screens/clutch/Instructions";
import PenaltyScan from "./screens/clutch/PenaltyScan";
import ClutchResult from "./screens/clutch/Result";

const router = createBrowserRouter([
  /* CLUTCH — Pressure Cam (public, real CarePlix face-scan under a penalty game) */
  {
    element: <ClutchLayout />,
    children: [
      { index: true, element: <GetStarted /> },
      { path: "details", element: <Details /> },
      { path: "instructions", element: <Instructions /> },
      { path: "play", element: <PenaltyScan /> },
      { path: "result", element: <ClutchResult /> },
    ],
  },
]);

const App = () => (
  <div style={{ position: "relative", zIndex: 1, minHeight: "100vh" }}>
    <RouterProvider router={router} />
  </div>
);

export default App;
